/* profumidicasa.it v17 — scheda prodotto
   1) <barra-acquisto>: su telefono, barra fissa in basso con prezzo e "Aggiungi"
      quando il bottone principale e' uscito dallo schermo verso l'alto
      (controllo su scroll passivo, al massimo una volta per fotogramma).
      Il bottone della barra invia il form principale (attributo form=), quindi
      aggiunta, errori e cassetto restano a product-form.js.
   2) <completa-il-regalo>: aggiunta in linea con la Cart API (/cart/add.js) e
      apertura del cassetto o della notifica di Dawn (renderContents). Se il
      metafield e' vuoto chiede i consigli complementari all'endpoint delle
      raccomandazioni e sostituisce il contenuto se ce ne sono.
   Nessuna libreria. Caricato una volta con defer da main-product.liquid.
   Il movimento e' tutto in CSS (prefers-reduced-motion li'). */

(() => {
  const haPubSub = () => typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';

  /* Il cambio variante arriva anche dalla scelta rapida delle card (stesso id
     di sezione): conta solo se la variante e' quella ora nel form principale. */
  const eDelFormPrincipale = (variante, formId) => {
    if (!variante || !formId) return false;
    const input = document.getElementById(formId)?.querySelector('input[name="id"]');
    return !!input && String(input.value) === String(variante.id);
  };

  /* Formatta i centesimi col formato del negozio (shop.money_format). */
  function formattaMoneta(centesimi, formato) {
    const valore = (Number(centesimi) || 0) / 100;
    const [intero, decimali] = valore.toFixed(2).split('.');
    const separa = (sep) => intero.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    const mappa = {
      amount: `${separa(',')}.${decimali}`,
      amount_no_decimals: separa(','),
      amount_with_comma_separator: `${separa('.')},${decimali}`,
      amount_no_decimals_with_comma_separator: separa('.'),
      amount_with_apostrophe_separator: `${separa("'")}.${decimali}`,
      amount_no_decimals_with_apostrophe_separator: separa("'"),
      amount_with_space_separator: `${separa(' ')},${decimali}`,
      amount_no_decimals_with_space_separator: separa(' '),
      amount_with_period_and_space_separator: `${separa(' ')}.${decimali}`,
    };
    return (formato || '{{amount_with_comma_separator}} €').replace(
      /\{\{\s*(\w+)\s*\}\}/g,
      (_, chiave) => mappa[chiave] ?? mappa.amount
    );
  }

  if (!customElements.get('barra-acquisto')) {
    customElements.define(
      'barra-acquisto',
      class BarraAcquisto extends HTMLElement {
        connectedCallback() {
          /* Dentro la scelta rapida (quick-add-modal) la barra non serve:
             quick-add.css la nasconde e qui non si attiva nulla. */
          if (this.closest('quick-add-modal')) return;
          /* Una barra sola per pagina: se ce n'e' gia' una attiva, questa tace. */
          const attive = [...document.querySelectorAll('barra-acquisto.is-attiva')];
          if (attive.some((altra) => altra !== this)) return;

          const id = this.dataset.bottone;
          if (!id) return;
          /* Con id duplicati (sezione ripetuta) si usa il bottone della stessa
             sezione prodotto, non il primo della pagina. */
          const contenitore = this.closest('product-info') || document;
          this.bottone =
            [...contenitore.querySelectorAll('[id]')].find((el) => el.id === id && !el.closest('quick-add-modal')) ||
            null;
          this.mio = this.querySelector('button');
          if (!this.bottone || !this.mio) return;
          this.classList.add('is-attiva');

          this.prezzo = this.querySelector('[data-prezzo-barra]');
          this.testo = this.querySelector('[data-testo-barra]');
          this.hidden = false;

          /* Scroll passivo + un solo rAF per fotogramma. Non IntersectionObserver:
             con un salto (ancora, ritorno alla pagina, lancio veloce) il bottone
             passa da "sotto lo schermo" a "sopra lo schermo" senza mai cambiare
             stato di intersezione e la barra non comparirebbe. */
          this.inAttesa = false;
          this.controlla = () => {
            if (this.inAttesa) return;
            this.inAttesa = true;
            requestAnimationFrame(() => {
              this.inAttesa = false;
              this.mostra(this.bottone.getBoundingClientRect().bottom < 0);
            });
          };
          window.addEventListener('scroll', this.controlla, { passive: true });
          window.addEventListener('resize', this.controlla, { passive: true });
          this.controlla();

          this.mutazioni = new MutationObserver(() => this.sincronizza());
          this.mutazioni.observe(this.bottone, {
            attributes: true,
            attributeFilter: ['disabled', 'aria-disabled', 'class'],
            childList: true,
            subtree: true,
            characterData: true,
          });

          if (haPubSub()) {
            this.annulla = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
              if (!eDelFormPrincipale(data?.variant, this.mio.getAttribute('form'))) return;
              const nuovoPrezzo = data?.html?.querySelector('[data-prezzo-barra]');
              if (nuovoPrezzo && this.prezzo) this.prezzo.textContent = nuovoPrezzo.textContent.trim();
              this.sincronizza();
            });
          }
          this.sincronizza();
        }

        disconnectedCallback() {
          if (this.controlla) {
            window.removeEventListener('scroll', this.controlla);
            window.removeEventListener('resize', this.controlla);
          }
          this.mutazioni?.disconnect();
          this.annulla?.();
          if (this.classList.contains('is-attiva')) document.body.classList.remove('has-barra-fissa');
          this.classList.remove('is-attiva', 'is-visible');
        }

        sincronizza() {
          if (!this.mio || !this.bottone) return;
          const spento = this.bottone.disabled || this.bottone.getAttribute('aria-disabled') === 'true';
          this.mio.disabled = spento;
          this.mio.classList.toggle('loading', this.bottone.classList.contains('loading'));
          const etichetta = this.bottone.querySelector('span:not(.loading__spinner)');
          if (etichetta && this.testo) this.testo.textContent = etichetta.textContent.trim();
        }

        mostra(visibile) {
          if (this.classList.contains('is-visible') === visibile) return;
          this.classList.toggle('is-visible', visibile);
          document.body.classList.toggle('has-barra-fissa', visibile);
        }
      }
    );
  }

  if (!customElements.get('completa-il-regalo')) {
    customElements.define(
      'completa-il-regalo',
      class CompletaIlRegalo extends HTMLElement {
        connectedCallback() {
          /* Nella scelta rapida e' nascosto (quick-add-hidden): nessun fetch. */
          if (this.closest('quick-add-modal')) return;
          this.prezzoProdotto = parseInt(this.dataset.prezzoProdotto || '0', 10);
          this.cerca();

          this.addEventListener('click', (evento) => {
            const bottone = evento.target.closest('[data-aggiungi]');
            if (bottone) this.aggiungi(bottone);
          });

          this.addEventListener('change', (evento) => {
            const select = evento.target;
            if (!select.matches('[data-variante]')) return;
            const voce = select.closest('.completa__voce');
            const bottone = voce?.querySelector('[data-aggiungi]');
            if (bottone) bottone.dataset.variantId = select.value;
            if (voce) voce.dataset.prezzo = select.selectedOptions[0]?.dataset.prezzo || '0';
            this.aggiorna();
          });

          if (haPubSub()) {
            this.annulla = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
              const sezione = this.closest('product-info')?.dataset.section;
              if (!sezione || !eDelFormPrincipale(data?.variant, `product-form-${sezione}`)) return;
              if (typeof data.variant.price === 'number') {
                this.prezzoProdotto = data.variant.price;
                this.aggiorna();
              }
            });
          }

          if (this.dataset.url && this.dataset.fonte !== 'metafield') this.caricaConsigli();
        }

        disconnectedCallback() {
          this.annulla?.();
        }

        cerca() {
          this.lista = this.querySelector('[data-lista]');
          this.insieme = this.querySelector('[data-insieme]');
          this.errore = this.querySelector('[data-errore]');
        }

        caricaConsigli() {
          const carica = () =>
            fetch(this.dataset.url)
              .then((risposta) => risposta.text())
              .then((testo) => {
                const doc = new DOMParser().parseFromString(testo, 'text/html');
                const nuovo = doc.querySelector('completa-il-regalo');
                if (!nuovo || nuovo.dataset.fonte !== 'consigli') return;
                this.innerHTML = nuovo.innerHTML;
                this.dataset.fonte = 'consigli';
                this.cerca();
                this.aggiorna();
              })
              .catch(() => {});

          if ('IntersectionObserver' in window) {
            const osservatore = new IntersectionObserver(
              (voci, oss) => {
                if (!voci[0].isIntersecting) return;
                oss.disconnect();
                carica();
              },
              { rootMargin: '0px 0px 400px 0px' }
            );
            osservatore.observe(this);
          } else {
            carica();
          }
        }

        aggiorna() {
          if (!this.insieme) return;
          let totale = this.prezzoProdotto;
          this.querySelectorAll('.completa__voce').forEach((voce) => {
            totale += parseInt(voce.dataset.prezzo || '0', 10);
          });
          this.insieme.textContent = formattaMoneta(totale, this.dataset.moneyFormat);
        }

        mostraErrore(messaggio) {
          if (!this.errore) return;
          this.errore.textContent = messaggio || '';
          this.errore.hidden = !messaggio;
        }

        aggiungi(bottone) {
          if (bottone.classList.contains('is-loading')) return;
          this.mostraErrore('');
          bottone.classList.add('is-loading');
          bottone.setAttribute('aria-disabled', 'true');

          const carrello = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          const dati = new FormData();
          dati.append('id', bottone.dataset.variantId);
          dati.append('quantity', '1');
          if (carrello && typeof carrello.getSectionsToRender === 'function') {
            /* Come product-form.js: /cart/add.js restituisce gia' l'HTML delle
               sezioni del cassetto, cosi' renderContents non fa un secondo fetch. */
            dati.append('sections', carrello.getSectionsToRender().map((sezione) => sezione.id).join(','));
            dati.append('sections_url', window.location.pathname);
            carrello.setActiveElement?.(document.activeElement);
          }

          fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body: dati,
          })
            .then((risposta) => risposta.json())
            .then((risposta) => {
              if (risposta.status) {
                this.mostraErrore(risposta.description || risposta.message);
                return;
              }
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'completa-il-regalo',
                  productVariantId: bottone.dataset.variantId,
                  cartData: risposta,
                });
              }
              bottone.classList.add('is-added');
              setTimeout(() => bottone.classList.remove('is-added'), 2000);
              if (carrello && typeof carrello.renderContents === 'function') {
                carrello.renderContents(risposta);
              } else {
                window.location = window.routes.cart_url;
              }
            })
            .catch(() => this.mostraErrore(window.cartStrings?.error))
            .finally(() => {
              bottone.classList.remove('is-loading');
              bottone.removeAttribute('aria-disabled');
            });
        }
      }
    );
  }
})();
